import axios from "axios";
import * as actionTypes from "./actionTypes";
import { openSuccess, openError, openInfo } from "./notification"

export const getLocationList = list => ({
  type: actionTypes.GET_LOCATIONS,
  list
})

export const getSubLocationList = list => ({
  type: actionTypes.GET_SUBLOCATIONS,
  list
})

export const getLocations = () =>
  dispatch => {
    axios.get(`${process.env.REACT_APP_SERVER_URL}/api/location/`, {
    })
      .then(res => {
        if (res.data.results?.length > 0) {
          const locationList = res.data.results.map(item => {
            let floor_plan = ""
            if (item.floor_plan)
              floor_plan = item.floor_plan.replace("http://127.0.0.1:8000", process.env.REACT_APP_SERVER_URL)
            return { ...item, floor_plan }
          })
          dispatch(getLocationList(locationList));
        }

      })
      .catch((err) => {
        console.error("Failed to fetch locations:", err);
      });
  };

export const getSubLocations = () =>
  dispatch => {
    axios.get(`${process.env.REACT_APP_SERVER_URL}/api/sublocation/`, {
    })
      .then(res => {
        dispatch(getSubLocationList(res.data.results));
      })
      .catch((err) => {
        console.error("Failed to fetch sublocations:", err);
      });
  };

export const createLocation = (name, description) =>
  dispatch => {
    const token = localStorage.getItem("token");
    const headers = { Authorization: `Token ${token}` };
    axios
      .post(`${process.env.REACT_APP_SERVER_URL}/api/location/create`, {
        name,
        description
      }, { headers })
      .then(res => {
        if (res)
          dispatch(getLocations());
        dispatch(openSuccess(true, "Create Success!", "New Location has been created.", "Just now"));
      })
      .catch(() => {
        dispatch(openError(true, "Create Failed!", "There was an error to create.", "Just now"));
      });

  };

export const updateLocation = (pk, name, description) =>
  dispatch => {
    const token = localStorage.getItem("token");
    const headers = { Authorization: `Token ${token}` };
    axios
      .put(`${process.env.REACT_APP_SERVER_URL}/api/location/update/${pk}/`, {
        name,
        description
      }, { headers })
      .then(res => {
        if (res)
          dispatch(getLocations());
        dispatch(openInfo(true, "Update Success!", "The Location has been updated.", "Just now"));
      })
      .catch(() => {
        dispatch(openError(true, "Update Failed!", "There was an error to update.", "Just now"));
      });

  };

export const deleteLocation = (pk) =>
  dispatch => {
    const token = localStorage.getItem("token");
    const headers = { Authorization: `Token ${token}` };
    axios
      .delete(`${process.env.REACT_APP_SERVER_URL}/api/location/delete/${pk}/`, { headers })
      .then(res => {
        if (res){
          dispatch(getSubLocations());
          dispatch(getLocations());
        }
        dispatch(openSuccess(true, "Delete Success!", "The Location has been deleted.", "Just now"));
      })
      .catch(() => {
        dispatch(openError(true, "Delete Failed!", "There was an error to delete.", "Just now"));
      });
  };



export const createSubLocation = (name, description, location) =>
  dispatch => {
    const token = localStorage.getItem("token");
    const headers = { Authorization: `Token ${token}` };
    axios
      .post(`${process.env.REACT_APP_SERVER_URL}/api/sublocation/create`, {
        name,
        description,
        location
      }, { headers })
      .then(res => {
        if (res)
          dispatch(getSubLocations());
        dispatch(openSuccess(true, "Create Success!", "New Sub Location has been created.", "Just now"));
      })
      .catch(() => {
        dispatch(openError(true, "Create Failed!", "There was an error to create.", "Just now"));
      });

  };

export const updateSubLocation = (pk, name, description, location) =>
  dispatch => {
    const token = localStorage.getItem("token");
    const headers = { Authorization: `Token ${token}` };
    axios
      .put(`${process.env.REACT_APP_SERVER_URL}/api/sublocation/update/${pk}/`, {
        name,
        description,
        location
      }, { headers })
      .then(res => {
        if (res)
          dispatch(getSubLocations());
        dispatch(openInfo(true, "Update Success!", "The Sub Location has been updated.", "Just now"));
      })
      .catch(() => {
        dispatch(openError(true, "Update Failed!", "There was an error to update.", "Just now"));
      });

  };

export const deleteSubLocation = (pk) =>
  dispatch => {
    const token = localStorage.getItem("token");
    const headers = { Authorization: `Token ${token}` };
    axios
      .delete(`${process.env.REACT_APP_SERVER_URL}/api/sublocation/delete/${pk}/`, { headers })
      .then(res => {
        if (res)
          dispatch(getSubLocations());
        dispatch(openSuccess(true, "Delete Success!", "The Sub Location has been deleted.", "Just now"));
      })
      .catch(() => {
        dispatch(openError(true, "Delete Failed!", "There was an error to delete.", "Just now"));
      });
  };




